module.exports = __webpack_public_path__ + "img/holywoodskyline2.832d532f.png";